import { Component } from '@angular/core';
import { ParticipantCourseList, ParticipantCourseListDefaultValues } from '../../course/participant-course-list';
import { CourseService } from 'src/app/services/course.service';
import { AuthService } from 'src/app/services/auth.service';
import { FileService } from 'src/app/services/file.service';
import { CourseType } from '../../course/course-type';
import { Router } from '@angular/router';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-getting-started',
    templateUrl: './getting-started.component.html',
    styleUrls: ['./getting-started.component.scss'],
    standalone: false
})
export class GettingStartedComponent {

  startingCourse: ParticipantCourseList = ParticipantCourseListDefaultValues();
  loggedInUserPublicId: string = '';
  eyebrowLabel: string = 'Your current course';
  ctaLabel: string = 'Continue';
  translations: any;

  constructor(
    private courseservice: CourseService,
    private authservice: AuthService,
    private fileservice: FileService,
    private router: Router,
    private translationService: TranslationService)
  { }

  ngOnInit(): void {
    this.loggedInUserPublicId = this.authservice.getUserLoginData().publicId;
    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
        this.refreshLabels();
      }
    });
    this.searchStartingCourse();
  }

  get progressPercent(): number {
    const status = this.normalizeStatus(this.startingCourse.enrollmentStatus);
    if (status === 'Completed') {
      return 100;
    }
    if (status === 'InProgress') {
      return 55;
    }
    return 0;
  }

  get progressLabel(): string {
    const status = this.normalizeStatus(this.startingCourse.enrollmentStatus);
    if (status === 'Completed') {
      return this.translations?.['completedText'] || 'Completed';
    }
    if (status === 'InProgress') {
      return `${this.progressPercent}% complete`;
    }
    return this.translations?.['notStartedText'] || 'Not started yet';
  }

  public searchStartingCourse(): void {
    this.courseservice.getStartingCourseForParticipant().subscribe({
      next: (data) => {
        this.startingCourse = data;
        this.refreshLabels();
      },
      error: () => {},
      complete: () => {
        if (this.startingCourse.courseThumbnailIconId) {
          this.openThumbnailImage(this.startingCourse.courseThumbnailIconId).then(url => {
            this.startingCourse.thumbnailUrl = url;
          }).catch(() => {});
        }
      }
    });
  }

  handleFavouriteClick(): void {
    this.searchStartingCourse();
  }

  goToCourses(): void {
    this.router.navigateByUrl('/participants/courses');
  }

  private refreshLabels(): void {
    if (!this.translations) {
      return;
    }
    if (this.startingCourse.courseType == CourseType.GettingStarted) {
      this.eyebrowLabel = this.translations['gettingStartedText'] || 'Getting started';
    } else {
      this.eyebrowLabel = this.translations['yourCurrentCourseText'] || 'Your current course';
    }
    this.ctaLabel = this.resolveCtaLabel(this.startingCourse.enrollmentStatus);
  }

  private normalizeStatus(status: string): string {
    return (status || '').replace(/\s+/g, '');
  }

  private resolveCtaLabel(enrollmentStatus: string): string {
    const status = this.normalizeStatus(enrollmentStatus);
    if (status === 'Completed') {
      return this.translations?.['reviewCourseText'] || 'Review course';
    }
    if (status === 'InProgress') {
      return this.translations?.['continueText'] || 'Continue';
    }
    return this.translations?.['startCourseCtaText'] || 'Start course';
  }

  public openThumbnailImage(id: any): Promise<string> {
    return new Promise((resolve, reject) => {
      this.fileservice.downloadFile(id).subscribe({
        next: (response) => {
          resolve(response.url);
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }
}
